/**
 *
 * WidgetResumeActionPlans
 *
 */

import React, { useState, useEffect } from "react"
import { Doughnut } from "react-chartjs-2"
import { uuid } from "../../utils/functions"
import { loadTexts } from "../../utils/i18n"
import "./index.less"

function WidgetResumeActionPlans({ data }) {
  const intl = loadTexts("tracking")
  const [chartData, setChartData] = useState({
    data: {
      datasets: [
        {
          data: [0, 0, 0, 0],
          borderWidth: 0,
          backgroundColor: ["#55C8AE", "#BDBDBD", "#F2C94C", "#E37879"],
          weight: 0.3,
        },
      ],
      text: "0%",
    },
    options: {
      maintainAspectRatio: false,
      cutoutPercentage: 80,
      responsive: false,
      tooltips: {
        enabled: true,
        titleFontSize: 13,
        displayColors: false,
        yPadding: 8,
        xPadding: 12,
        backgroundColor: "rgba(0, 0, 0, 0.75)",
        callbacks: {
          label(tooltipItem) {
            var label = data[tooltipItem.index].tooltip || ""
            return label
          },
        },
      },
      legend: {
        display: false,
      },
    },
  })

  useEffect(() => {
    let chart = chartData
    const values = data.flatMap((e) => parseInt(e.value * 10))
    const colors = data.flatMap((e) => e.color)
    chart.data.datasets[0].data = values
    chart.data.datasets[0].backgroundColor = colors
    if (data[0]) chart.data.text = `${data[0].value}%`
    setChartData(chart)
  }, [data])

  return (
    <div className="WidgetResumeActionsPlans-Component">
      <div className="WidgetResumeActionsPlans-Component-chart">
        <Doughnut
          data={chartData.data}
          options={chartData.options}
          width={125}
          height={105}
        />
        <div className="WidgetResumeActionsPlans-Component-chart-text">
          <b>{chartData.data.text}</b>
          <span>{intl.WidgetResumeActionPlans.labels.completed}</span>
        </div>
      </div>

      <div className="WidgetResumeActionsPlans-Component-right">
        {data.map((v) => (
          <div key={uuid()}>
            <span style={{ color: v.color }}>{v.value || 0}%</span> {v.name}
          </div>
        ))}
      </div>
    </div>
  )
}

WidgetResumeActionPlans.defaultProps = {
  data: [],
}

export default React.memo(WidgetResumeActionPlans, (prevProps, nextProps) => {
  return prevProps.data.length != nextProps.data.length
})
